








































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
    propertiesMatching: require './properties_matching.vue'
    stagesMatching: require './stages_matching.vue'

  data: ->
    current_user: Session.current_user
    rd_station_crm_setting: if Session.current_user.rd_station_crm_setting.id? then Session.current_user.rd_station_crm_setting else new RDStationCRMSetting()
    add_contacts_to_rd_station_crm: Session.current_user.rd_station_crm_setting.add_contacts_to_rd_station_crm
    rd_station_crm_api_key: Session.current_user.rd_station_crm_api_key || ''
    api_fields: []
    integration_stages: []
    matching: []
    matching_stages: []
    update_stages_all_users: false
    has_stages_api: true
    loading_api_key: false
    pipelines: []
    selected_pipeline: { stage_query: null }
    copy_settings: false
    user_rd_setting: null
    users_options_rd: []
    rd_setting_copy: []

  methods:
    toggleMarkAddContatsToRDStationCRM: ->
      @add_contacts_to_rd_station_crm = !@add_contacts_to_rd_station_crm

    toggleCopySettings: ->
      @copy_settings = !@copy_settings

    loadUsersRDStation: ->
      roles = [ User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager'] ]
      company_id = Session?.current_company?.id
      new UsersResource().index(@loadUsersRDStationSuccess, null, params: {q: {s: 'name asc', role_in: roles}, company_id: company_id})

    loadUsersRDStationSuccess: (data) ->
      for user in data.users
        if user.rd_station_crm_api_key != null
          @rd_setting_copy.push (user)
          @users_options_rd.push ({ value: {user_id: user.id}, text: user.firstAndLastName() })
      @users_options_rd.unshift(value: null, text: @$t('general.label.user'))

    copy: ->
      if @user_rd_setting.user_id != null
        data = @rd_setting_copy.filter (item) => item.id == @user_rd_setting.user_id
        data_rd = data[0].rd_station_crm_setting
        @add_contacts_to_rd_station_crm = data_rd.add_contacts_to_rd_station_crm
        @rd_station_crm_setting.triggers = data_rd.triggers
        @rd_station_crm_setting.properties_matching = data_rd.properties_matching
        @rd_station_crm_setting.metadata.pipeline_id = data_rd.metadata.pipeline_id
        @selected_pipeline = data_rd.metadata.pipeline_id
        @rd_station_crm_setting.stages_matching = data_rd.stages_matching

    save: ->
      @$validator.validateAll({@rd_station_crm_api_key}).then (success) =>
        @updateRDStationCRMApiKey() if success

    updateRDStationCRMApiKey: ->
      for stage in @matching_stages
        if !stage.reev || !stage.integration
          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'))

      Loader.on()
      params = {
        id: Session.current_user.id,
        @rd_station_crm_api_key,
        @update_stages_all_users,
        @user_to_update_stages,
        rd_station_crm_setting_attributes: {
          id: @rd_station_crm_setting.id,
          metadata: @rd_station_crm_setting.metadata,
          stage_id: @rd_station_crm_setting.stage_id,
          add_contacts_to_rd_station_crm: @add_contacts_to_rd_station_crm,
          triggers: @rd_station_crm_setting.triggers,
          properties_matching: @matching,
          stages_matching: @matching_stages
        }
      }
      new UsersResource().update(@updateRDStationCRMApiKeySuccess, @rdStationCRMErrors, params)

    removeRDStationCRMApiKey: ->
      @rd_station_crm_api_key = null
      @matching = []
      @matching_stages = []
      @rd_station_crm_setting.stages_matching = []
      Loader.on()
      params = {
        id: Session.current_user.id,
        @rd_station_crm_api_key,
        rd_station_crm_setting_attributes: {
          id: @rd_station_crm_setting.id,
          _destroy: true
        }
      }
      new UsersResource().update(@updateRDStationCRMApiKeySuccess, @rdStationCRMErrors, params)

    updateRDStationCRMApiKeySuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.rd_station_crm_api_key then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.feedback.rdStationCRMSuccess')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @rd_station_crm_api_key = data.user.rd_station_crm_api_key
      @has_stages_api = true
      @rd_station_crm_setting.stage_id = data.user.rd_station_crm_setting.stage_id
      @closeForm()
      intercom_event_name = if data.user.rd_station_crm_api_key then this.$t('integrations.rdStationCRMConnectEvent') else this.$t('integrations.rdStationCRMDisconnectEvent')
      IntercomCtrl.trackEvent(intercom_event_name)

    rdStationCRMErrors: (response, options={}) ->
      @handleApiErrors(response, options)
      if(response.body.rd_station_crm_setting)
        for error in response.body.rd_station_crm_setting
          @errors.add(error, this.$t('general.feedback.invalid'))

    setStagesRDStationCRM: (data) ->
      @rd_station_crm_setting.triggers = data

    matchingUpdated: (data) ->
      @matching = data

    matchingStagesUpdated: (data) ->
      @matching_stages = data

    updateUsers: (data) ->
      @update_stages_all_users = data.update_all_users
      @user_to_update_stages = data.user_id

    getTypeField: (type) ->
      return 'number' if type == 'enum'
      return 'tel' if type == 'phone'
      return 'date' if type == 'date'
      return 'number' if type == 'double'
      return 'number' if type == 'int'
      'text'

    loadRDStationCRMFields: ->
      return if @rd_station_crm_api_key == ''
      @has_stages_api = true
      @loadFields()
      @loadPipelines()

    loadFields: ->
      return if !@rd_station_crm_api_key

      opts = {
        params: { rd_station_crm_apikey: @rd_station_crm_api_key },
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      };

      self = @
      Vue.http.get("#{process.env.API_URL}/rd_station_crm/contact_properties", opts).then((response) ->
        body = response.body || []
        return unless Object.values(body)[0]

        if (Object.values(body)[0].length > 0 || Object.values(body)[0].length == undefined)
          self.api_fields = response.body
                              .filter((field) -> field.for == 'contact' || field.for == 'deal')
                              .map((field) -> { name: field.label, key: field._id, type: field.type, required: !field.required, origin: field.for })
      )

    loadPipelines: ->
      return if !@rd_station_crm_api_key

      opts = {
        params: { rd_station_crm_apikey: @rd_station_crm_api_key },
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      };

      @$http.get("#{process.env.API_URL}/rd_station_crm/deal_pipelines", opts).then((response) =>
        @pipelines = response.body.map (pipeline) -> {
          value: { stage_query: pipeline.id },
          text: pipeline.name,
          stages: pipeline.deal_stages.map (stage) -> { id: stage.id, name: stage.name }
        }

        @pipelines.unshift { value: { stage_query: null }, text: 'Selecione um funil' }
        firstQuery = @pipelines[0].value.stage_query

        if @rd_station_crm_setting.metadata
          if @rd_station_crm_setting.metadata.pipeline_id
            founded = @pipelines.filter((i) => i.value.stage_query == @rd_station_crm_setting.metadata.pipeline_id)
            @selected_pipeline = founded[0].value if founded[0] != null && founded != null

        if @selected_pipeline
          firstQuery = @selected_pipeline.stage_query

        @loadByNewPipeline({
          pipeline: {
            stage_query: firstQuery
          }
        })
      )

    loadByNewPipeline: (data) ->
      if (!@rd_station_crm_setting.metadata)
        @rd_station_crm_setting.metadata = { pipeline_id: data.pipeline.stage_query }
      else
        @rd_station_crm_setting.metadata.pipeline_id = data.pipeline.stage_query
      pipeline = @pipelines.filter((i) => i.value.stage_query is data.pipeline.stage_query)[0]
      @selected_pipeline = pipeline.value
      if (pipeline.stages)
        @has_stages_api = true
        @integration_stages = pipeline.stages
      else
        @integration_stages = []

    changePipeline: (data) ->
      @rd_station_crm_setting.metadata.pipeline_id = data.pipeline.stage_query
      @rd_station_crm_setting.metadata.stages_matching = []
      @loadByNewPipeline(data)

    closeForm: ->
      @$router.push path: '/configuracoes/integracoes'

    validate_api_key: ->
      @loading_api_key = true
      opts = {
        params: { rd_station_crm_apikey: @rd_station_crm_api_key }
      }
      @$http.get("#{process.env.API_URL}/rd_station_crm/contact_properties", opts).then ((response) =>
        @errors.clear()
        @loadRDStationCRMFields()
        @loading_api_key = false
      ), ((response) =>
        @loading_api_key = false
        @errors.add('rd_station_crm_api_key', this.$t('integrations.feedback.invalidApiKey'))
      )

  watch:
    rd_station_crm_api_key: ->
      return if @loading_api_key
      @validate_api_key()

  mounted: ->
    Tooltip.initialize()
    @loadRDStationCRMFields()
    @loadUsersRDStation()
    rd_station_crm_setting: ->
      @copy()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/rd_station_crm.vue